/**
 * SDK version information
 * Values are substituted at build time via tsup's define option
 */

export interface VersionInfo {
  version: string
  gitSha: string
  buildTime: string
}

/** SDK semantic version from package.json */
export const VERSION: string = process.env.SDK_VERSION ?? 'dev'

/** Git commit SHA at build time (short form) */
export const GIT_SHA: string = process.env.SDK_GIT_SHA ?? 'unknown'

/** Build timestamp in ISO format */
export const BUILD_TIME: string = process.env.SDK_BUILD_TIME ?? ''

/**
 * Get full version info object
 */
export function getVersionInfo(): VersionInfo {
  return {
    version: VERSION,
    gitSha: GIT_SHA,
    buildTime: BUILD_TIME
  }
}
